import React from 'react';

import { Headband } from '@hpstellar/icons';
import { Cart, ChevronRight } from '@hpstellar/vis-icons';
import { CategoryTile, Typography } from '@hpstellar/core/visId';
import TypographyOld from '@hpstellar/core/Typography';
import Button from '@hpstellar/core/visId/Button';

import useSiteConfig from '../../hooks/useSiteConfig';

import './css/search-support-static-tiles.less';


const getStaticSupportTiles = siteConfig => {
    const variant = 'product';
    const { basename } = siteConfig || {};

    const btnProps = {
        // style: {
        //     fontWeight: 700,
        //     display: 'flex',
        //     alignItems: 'center',
        //     marginTop: '4px'
        // }
        className: 'srp-static-tile-view-button'
    }

    const descProps = {
        className: 'srp-static-tile-description'
    }

    const orderStatusLink = `${basename}/MyAccountOrderStatusView`;
    const customerServiceLink = `${basename}/ContentView?eSpotName=CustomerService&catalogId=10051&langId=-1&storeId=10151`;
    return [
        {
            title: <TypographyOld variant='titleS' tag='p'>Your purchases</TypographyOld>,
            image:<Cart size='m' style={{backgroundColor: '#A3ACFA', display: 'inline'}} />,
            description: (
                <>
                    <Typography variant='caption' tag='p' {...descProps}>Are you looking for order status or shipping information?</Typography>
                    <Button to={orderStatusLink} theme='dark' variation='tertiary' {...btnProps}>View your purchases <ChevronRight size='s'/></Button>
                </>
            ),
            variant,
            to: orderStatusLink ,
            className: 'srp-support-purchases-tile'
        },
        {
            title: <TypographyOld variant='titleS' tag='p'>Customer service</TypographyOld>,
            image: (
                <Headband size='m' style={{backgroundColor: '#C1FCAA'}} viewBox='0 0 80 80' height='40px' width='40px' />
            ),
            description: (
                <>
                    <Typography variant='caption' tag='p' {...descProps} >Need help? Visit our support page or contact us</Typography>
                    <Button to={customerServiceLink} theme='dark' variation='tertiary' {...btnProps}>Visit customer service <ChevronRight size='s'/></Button>
                </>
            ),
            to: customerServiceLink,
            variant,
            className: 'srp-support-customer-tile'
        }
    ]
};

export default props => {
    const siteConfig = useSiteConfig();
    const tiles = getStaticSupportTiles(siteConfig);
    return (
        <div className='srp-default-support-tiles'>
            {
                tiles.map((tile, idx) => (
                    <CategoryTile
                        key={idx}
                        imageWrapperClassName='srp-support-tile-image-wrapper'
                        {...tile}
                    />
                ))
            }
        </div>
    );
}